import { useEffect, type MutableRefObject } from 'react';

/**
 * OAuth cancel/return can restore the login page from browser cache with stale
 * React state (spinner stuck). Reset local loading when the page becomes active again.
 */
export const useResetOAuthButtonLoadingOnReturn = (
  setIsLoading: (value: boolean) => void,
  isMountedRef: MutableRefObject<boolean>,
): void => {
  useEffect(() => {
    const resetLoading = () => {
      if (!isMountedRef.current) return;
      setIsLoading(false);
    };

    window.addEventListener('pageshow', resetLoading);
    window.addEventListener('focus', resetLoading);
    document.addEventListener('visibilitychange', resetLoading);

    return () => {
      window.removeEventListener('pageshow', resetLoading);
      window.removeEventListener('focus', resetLoading);
      document.removeEventListener('visibilitychange', resetLoading);
    };
  }, [setIsLoading, isMountedRef]);
};
